import ListItemIcon from '@mui/material/ListItemIcon';
import { useLocation } from 'react-router-dom';

import type { INavMenu } from '@/components/layout/navbar/navbar.config';

import { StyledSideBarListItem, StyledSidebarMenuLink } from './SidebarNavMenuItem.styles';

interface ISidebarNavMenuItem {
  menuItem: INavMenu;
  toggleText: boolean;
  onClick?: () => void;
}

function SidebarNavMenuItem({ menuItem, toggleText, onClick }: ISidebarNavMenuItem) {
  const location = useLocation();
  const isActive = location.pathname === menuItem.link;
  return (
    <StyledSideBarListItem className={isActive ? 'active' : ''} onClick={onClick}>
      <StyledSidebarMenuLink to={menuItem.link}>
        <ListItemIcon
          sx={{
            color: (theme) => theme.palette.common.white,
          }}
        >
          <menuItem.icon />
        </ListItemIcon>
        {toggleText && menuItem.name}
      </StyledSidebarMenuLink>
    </StyledSideBarListItem>
  );
}

export default SidebarNavMenuItem;
